<div class="feature-svg-container d-flex flex-column align-items-center">
    <div class="position-relative">
        <svg
            data-cy="wdx-feature-svg"
            class="feature-svg feature-svg--{{ size }}"
        >
            <ng-container>
                @switch (svg) {
                    @case (FEATURE_SVG.AccessDenied) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/access-denied.svg#access-denied"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.AppNoGoals) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/app-no-goals.svg#app-no-goals"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.AppNoFamily) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/app-no-family.svg#app-no-family"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.AppNoProducts) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/app-no-products.svg#app-no-products"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.AppNoSourceOfWealth) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/app-no-source-of-wealth.svg#app-no-source-of-wealth"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientCharity) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/client-charity.svg#client-charity"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientCorporate) {
                        <svg:use
                            xlink:href="assets/images/svg/client-corporate.svg#client-corporate"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientIndividual) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/client-individual.svg#client-individual"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientJoint) {
                        <svg:use
                            xlink:href="assets/images/svg/client-joint.svg#client-joint"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientTrust) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/client-trust.svg#client-trust"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.DashboardNoAccess) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/dashboard-no-access.svg#dashboard-no-access"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.EmptyFolder) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/empty-folder.svg#empty-folder"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.InboxEmpty) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/inbox-empty.svg#inbox-empty"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.NoChatData) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/no-chat-data.svg#no-chat-data"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.NoData) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/no-data.svg#no-data"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.NoListData) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/no-list-data.svg#no-list-data"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.PageNotFound) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/page-not-found.svg#page-not-found"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.SelectDataFromMenu) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/select-data-from-menu.svg#select-data-from-menu"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.Workspace) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/workspace.svg#workspace"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.Comments) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/comments.svg#comments"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ThumbsUp) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/thumbs-up.svg#thumbs-up"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.Success) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/circle-check-duotone-regular.svg#circle-check-duotone-regular"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.TableCellsLock) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/table-cells-lock.svg#table-cells-lock"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.UserSearch) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/user-magnifying.svg#user-magnifing"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.UserClock) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/user-clock.svg#user-clock"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.xMark) {
                        <svg:use
                            data-cy="wdx-feature-svg-use"
                            xlink:href="assets/images/svg/x-mark.svg#x-mark"
                        ></svg:use>
                    }
                }
            </ng-container>
        </svg>
    </div>

    <h6
        class="mt-3 mb-3 text-center"
        data-cy="wdx-feature-svg-label"
        [textContent]="label"
    ></h6>
    <ng-content></ng-content>
</div>
